import { RootState } from '@/modules/ewwms/store';

import { GetterTree } from 'vuex';
import { State } from './state';
import { Umfuhr } from '@/modules/ewwms/models/Lager/UmfuhrModels';

export type Getters = {
  umfuhren(state: State): Array<Umfuhr>;
  // umfuhrpos(state: State): Array<Umfuhrpos>,
};

export const getters: GetterTree<State, RootState> & Getters = {
  umfuhren(state: State) {
    return state.umfuhren;
  },

  // umfuhrpos(state: State) {
  //   return state.umfuhrpos;
  // },
};
